import { useState } from "react"
import { Copy, X } from "react-feather"
import { toastSuccess } from "../../../helper/Toast/Toast"

export const TextViewPopup = ({ title = "Details", text = "", links = [], children, onClose }) => {
    const [copiedUrl, setCopiedUrl] = useState("")

    const copyLink = async (url) => {
        if (!navigator.clipboard || !url) return

        await navigator.clipboard.writeText(url)
        setCopiedUrl(url)
        toastSuccess("Link copied successfully")
        window.setTimeout(() => setCopiedUrl(""), 1500)
    }

    return (
        <div className="seminar-backdrop custom">
            <div className="modal-dialog modal-dialog-centered seminar-dialog text-view-dialog">
                <div className="modal-content seminar-content" role="dialog" aria-modal="true" aria-label={title}>
                    <div className="d-flex align-items-center justify-content-between seminar-header">
                        <h6 className="m-0 fw-bold">{title}</h6>
                        <button type="button" className="btn-close btn-close-white seminar-close" onClick={onClose} aria-label="Close" />
                    </div>

                    <div className="seminar-body text-view-content">
                        {text && <p className="text-view-text">{text}</p>}
                        {children}
                        {links.length > 0 && (
                            <div className="text-view-links">
                                {links.map((link) => (
                                    <div key={link.url} className="text-view-link-row">
                                        <a
                                            href={link.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-view-link"
                                        >
                                            {link.label || link.url}
                                        </a>
                                        <button
                                            type="button"
                                            className="border-left ps-2 text-view-copy-btn"
                                            onClick={() => copyLink(link.url)}
                                            aria-label={copiedUrl === link.url ? "Link copied" : "Copy link"}
                                            title={copiedUrl === link.url ? "Link copied" : "Copy link"}
                                        >
                                            <Copy size={15} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-end seminar-footer">
                        <button type="button" className="btn btn-danger seminar-btn-cancel" onClick={onClose}>
                            <X size={15} className="me-1" />
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
